import { CalendarView } from '../Enums/CalendarView'
import { CalendarEventDTO } from './CalendarEventDTO'

export class CalendarOptions {
    /** Represent Name Of Calendar*/
    Name: string
    /** Represent DefaultView Of Calendar*/
    DefaultView: CalendarView = CalendarView.Month
    /** Represent OnEventClickFunction Of Calendar*/
    OnEventClickFunction: any
    /** Represent CalendarViews Of Calendar*/
    CalendarViews: CalendarView[]=[CalendarView.Agenda,CalendarView.Daily,CalendarView.Month,CalendarView.Weekly]
    /** Represent OnDayClickFunction Of Calendar*/
    OnDayClickFunction: any
    /** Represent EventList Of Calendar*/
  /**  Represent value of the label*/
  LabelValue:string
  
 /**  Represent Key of the label*/
 LabelKey:string
    EventList: CalendarEventDTO[]
  /** Set Allowc Calendar Weekends Of Calendar*/
    AllowCalendarWeekends:boolean
      /** Set Calendar Visible Of Calendar*/
    CalendarVisible:boolean
   /** Set DefaultDate  Of Calendar*/
    DefaultDate:Date= new Date()
}